import { Link } from 'react-router-dom';
import { useEffect, useReducer, useState } from 'react';
import { initialstate, myreducer, fetchbygetmethod } from '../Commonfiles/Myreducer';
import Spinner from '../Commonfiles/spinner';
import Nodatafound from '../Commonfiles/nodatafound';
import { Gotohome } from '../Commonfiles/checkfortoken';
import toogleimg from '../Images/image.png';
import '../DirectSeller/leftmenu.css';

function DSleftmenu(props) {
    const [mydata, setmydata] = useReducer(myreducer, initialstate);
    const [menuVisible, setMenuVisible] = useState(true);
    const [menuVisible1, setMenuVisible1] = useState(false);
    const imagefromdb = "./uploads/";
    const imagedefault = "/assets/images/users/avatar-1.jpg";

    async function loaddata() {
        fetchbygetmethod(setmydata, 'profileinformation', { tempid: sessionStorage.getItem("tempID") });
    }

    useEffect(() => {
        loaddata();
    }, []);

 

    const toggleMenu = (event) => {
        const targetMenuId = event.currentTarget.getAttribute('data-target');
        const targetMenu = document.getElementById(targetMenuId);
        targetMenu.style.display = targetMenu.style.display === 'none' ? 'block' : 'none';
    };

    const handleSidebarToggle = () => {
        setMenuVisible(!menuVisible);
    };

    const handleSidebarToggle1 = () => {
        setMenuVisible1(!menuVisible1);
      };
    
      // Set sidebar visibility based on screen size
      useEffect(() => {
        const handleResize = () => {
          if (window.innerWidth <= 768) {
            setMenuVisible1(false); // Hide sidebar on mobile
          } else {
            setMenuVisible1(true);  // Show sidebar on desktop
          }
        };
    
        handleResize(); // Run once on page load
    
        window.addEventListener('resize', handleResize); // Listen on resize
    
        return () => window.removeEventListener('resize', handleResize); // Clean up
      }, []);
    

    return (
        <div  className={`left side-menu ${menuVisible1 ? 'open' : ''}`} >

            <div className="sidebar-inner slimscrollleft">
                <div className="user-details">
                    <div className="text-center">
                        <img 
                            src={mydata.mypost.length > 0 && mydata.mypost[0].ApplicantPhoto ? imagefromdb + mydata.mypost[0].ApplicantPhoto : process.env.PUBLIC_URL + imagedefault} 
                            alt="" className="img-circle" 
                        />
                    </div>
                    <div className="user-info">
                        <div className="dropdown">
                            <a href="#" className="dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
                                {mydata.mypost.length > 0 && mydata.mypost[0].ApplicantName}
                            </a>
                        </div>
                    </div>
                </div>
                <div id="sidebar-menu">
                <ul className={`visible ${menuVisible ? 'open' : ''}`} >


                        
                        <li className="has_sub" data-target="updateprofile" onClick={toggleMenu}>
                            <a href="javascript:void(0);" className="waves-effect">
                                <i className="mdi mdi-album"></i>
                                <span>User Profile</span>
                                <span className="pull-right">
                                    <i className="mdi mdi-plus"></i>
                                </span>
                            </a>
                            <ul id='updateprofile' className="list-unstyled" style={{ display: 'none' }}>
                            <li><Link to='DSDashboard'>Dashboard</Link></li>
                                <li><Link to='personaldetails'>Personal Profile</Link></li>
                                <li><Link to='communicationdetail'>Communication Details</Link></li>
                                <li><Link to='bankdetails'>Bank Details</Link></li>
                                <li><Link to='joiningdetail'>Joining Details</Link></li>
                                <li><Link to="uploadpicture">Upload Picture</Link></li>
                                <li><Link to="changepassword">Change Password</Link></li>
                                <li><Link to="idcard">Id Card</Link></li>
                            </ul>
                        </li>
                        <li className="has_sub" data-target="reports" onClick={toggleMenu}>
                            <a href="javascript:void(0);" className="waves-effect">
                                <i className="mdi mdi-album"></i>
                                <span>Reports</span>
                                <span className="pull-right">
                                    <i className="mdi mdi-plus"></i>
                                </span>
                            </a>
                            <ul id='reports' className="list-unstyled" style={{ display: 'none' }}>
                                <li><Link to="Yourgroup">Your Group</Link></li>
                                <li><Link to='awarenessincome'>Awareness Income Details</Link></li>
                                <li><Link to='yourbusiness'>Your Business</Link></li>
                                <li><Link to='businesstransaction'>Consolited Business</Link></li>
                                <li><Link to='monthlystate'>Monthly Statement</Link></li>
                                <li><Link to='financialyear'>Financial Year Purchasing </Link></li>
                                <li><Link to='businessclub'>Business Building Club </Link></li>
                                <li><Link to='iwd'>Income Awareness Detail</Link></li>
                                <li><Link to='matchingpointds'>Matching Point Income Awareness</Link></li>
                                <li><Link to='directi'>Direct Income</Link></li>
                                <li><Link to='tentetivedirecti'>Tentetive Direct Income</Link></li>
                                <li><Link to='directia'>Direct Income Awareness</Link></li>
                                <li><Link to='tentetivedirectia'>Tentetive Direct Income Awareness</Link></li>
                            </ul>
                        </li>
                        <li><Link to='producttraning' className="waves-effect"><i className="mdi mdi-home"></i><span>Product Training</span></Link></li>
                        <li><Link to='DsproductList' className="waves-effect"><i className="mdi mdi-home"></i><span>Product List</span></Link></li>
                    </ul>
                </div>
                <div className="clearfix"></div>
            </div>
            {/* <div
  className="menu-icon"
  onClick={handleSidebarToggle}
  style={{
    position: 'absolute',
    top: '10px',
    left: '10px',
    zIndex: 9999,
    background: 'white',
    padding: '5px',
    borderRadius: '50%',
    cursor: 'pointer'
  }}
>
  <img src={toogleimg} alt="menu icon" style={{ width: '30px', height: '30px' }} />
</div> */}





        </div>
    );
}

export default DSleftmenu;
